export default function QuestionField({ q, value, onChange }) {
  const tid = `question-${q.id}`;
  if (q.type === "textarea")
    return <textarea data-testid={tid} className="field min-h-[110px]" value={value || ""} onChange={(e) => onChange(e.target.value)} />;
  if (q.type === "date")
    return <input data-testid={tid} type="date" className="field" value={value || ""} onChange={(e) => onChange(e.target.value)} />;
  if (q.type === "number")
    return <input data-testid={tid} className="field" inputMode="numeric" value={value || ""} onChange={(e) => onChange(e.target.value)} />;
  if (q.type === "select")
    return (
      <select data-testid={tid} className="field" value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <option value="">Choose one…</option>
        {(q.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  if (q.type === "checkbox") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div className="grid sm:grid-cols-2 gap-3" data-testid={tid}>
        {(q.options || []).map((o, i) => (
          <label key={o} className={`flex items-center gap-3 min-h-[52px] px-4 rounded-xl border-2 cursor-pointer text-lg ${arr.includes(o) ? "border-[#2B5338] bg-green-50" : "border-[#E6DBCF] bg-white"}`}>
            <input type="checkbox" data-testid={`${tid}-option-${i}`} className="w-6 h-6 accent-[#2B5338]" checked={arr.includes(o)}
              onChange={() => onChange(arr.includes(o) ? arr.filter((x) => x !== o) : [...arr, o])} />{o}
          </label>
        ))}
      </div>
    );
  }
  if (q.type === "yesno")
    return (
      <div className="flex gap-3" data-testid={tid}>
        {["Yes", "No"].map((o) => (
          <button type="button" key={o} data-testid={`${tid}-${o.toLowerCase()}`} onClick={() => onChange(o)}
            className={`flex-1 min-h-[52px] rounded-xl border-2 text-lg font-semibold ${value === o ? "border-[#8C3415] bg-[#8C3415] text-white" : "border-[#E6DBCF] bg-white"}`}>{o}</button>
        ))}
      </div>
    );
  return <input data-testid={tid} className="field" value={value || ""} onChange={(e) => onChange(e.target.value)} />;
}
